import { useEffect, useState } from 'react';
import { devices } from 'components/services/devices';

export const throttle = <T>(callback: (this: T) => void, limit = 1000) => {
  let lastFunc: ReturnType<typeof setTimeout> | null;
  let lastRan: number | undefined;

  return function (this: T) {
    if (!lastRan) {
      callback.apply(this);
      lastRan = Date.now();
    } else {
      if (lastFunc) {
        clearTimeout(lastFunc);
      }
      lastFunc = setTimeout(
        () => {
          if (Date.now() - lastRan! >= limit) {
            callback.apply(this);
            lastRan = Date.now();
          }
        },
        limit - (Date.now() - lastRan),
      );
    }
  };
};

export const useMobileWidth = () => {
  const [isMobile, setMobile] = useState(window.innerWidth <= devices.mobileL);
  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth <= devices.mobileL);
    };
    const throttledHandleResize = throttle(handleResize);
    window.addEventListener('resize', throttledHandleResize);
    return () => window.removeEventListener('resize', throttledHandleResize);
  }, []);
  return isMobile;
};
